var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRates = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 22,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  clipPath: "url(#Rates_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m7.597 21.254-6.588-6.588a.93.93 0 0 1 0-1.314L11.557 2.804l6.476.587a.935.935 0 0 1 .848.848l.587 6.477L8.929 21.254a.93.93 0 0 1-1.314 0zM11.557 8.079 5.62 14.014M14.184 10.716l-5.926 5.926"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.448 6.057c-1.155 0-2.096-1.249-2.096-2.796s.94-2.795 2.096-2.795 2.097 1.249 2.097 2.795"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Rates_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.272 0h19.652v22H.272z"
})))));
export default SvgRates;